/**
 * @module <%=name%>
 * Action creator for <%=name%> object
 */

import * as types from './actiontypes';

export function getLanguages(url, resource) {
	return {
		type: types.GET_LANGUAGES,
		meta: {
			api: {
				url,
				method: 'GET',
				data: {
					resource
				}
			}
		}
	};
}
